<template>
    <div>
        <div class="default-table sortable">


            <div class="default-table-header">

                <div class="table-header-cell"
                     :class=" $route.query['order_by'] === column.name ? 'asc'  : $route.query['order_by'] === '-' + column.name ? 'des' : ''"
                     @click="$emit('sort',column.name)" v-for="column in data.columns">
                    {{ column.displayName }}
                </div>
            </div>
            <div class="default-table-body">

                <div class="default-table-row" v-for="row in data.rows">
                    <div class="table-body-cell" v-for="column in data.columns">
                        <div>{{ column.name === 'price' ? priceFormatter(row.content[column.name]) : row.content[column.name] }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-table">
            <div class="mobile-table-row" v-for="row in data.rows">
                <div class="rows" v-for="column in data.columns">
                    <div class="mobile-table-row-content">
                        <div>
                            {{ column.displayName }}
                        </div>
                        <div>
                            {{ column.name === 'price' ? priceFormatter(row.content[column.name]) : row.content[column.name] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-pagination :value="current"
                      @input="pageChange"
                      :page-count="paginationTotalCount"
                      :classes="bootstrapPaginationClasses"
                      :labels="paginationAnchorTexts"></v-pagination>
    </div>

</template>

<script>
import vPagination from 'vue-plain-pagination';
import {mapGetters} from "vuex";
import animateScrollTo from "animated-scroll-to";

export default {
    props: ["data"],
    data() {
        return {
            bootstrapPaginationClasses: {
                ul: 'pagination',
                li: 'page-item',
                liActive: 'active',
                liDisable: 'disabled',
                button: 'page-link'
            },
            paginationAnchorTexts: {
                first: null,
                prev: '‹',
                next: '›',
                last: null,
            }
        }
    },
    components: {
        vPagination
    },
    computed: {
        ...mapGetters(["paginationTotalCount"]),
        current() {
            return parseInt(this.$route.query.page) || 1;
        },

    },
   
    methods: {
        pageChange(value) {

            this.$emit('pageChanged', value);

            this.$emit('scrollTop');
        },
        priceFormatter(value) {
            return value.replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    }

}
</script>

<style lang="scss" scoped>

.default-table {
    width: 100%;
    display: table;

    @media screen and (max-width: 768px) {
        display: none;
    }
}

.default-table-header {
    display: table-header-group;
    color: rgb(255, 255, 255);
    background-color: rgb(0, 102, 136);
    border-bottom: 1px solid #111;
}

.sortable {
    .table-header-cell {
        &::after {
            content: '';
            display: block;
            background-image: url('../assets/images/sort_both.png');
            width: 24px;
            height: 18px;
            position: absolute;
            right: 0;
            top: 12px;

        }
    }

    .table-header-cell.asc {

        &::after {
            background-image: url('../assets/images/sort_asc.png');
        }
    }

    .table-header-cell.des {

        &::after {
            background-image: url('../assets/images/sort_asc.png');
            transform: rotateX(180deg);
        }
    }

}

.table-header-cell {
    min-width: 120px;
    display: table-cell;
    padding: 10px;
    border-bottom: 1px solid black;
    cursor: pointer;
    font-size: 14px;
    font-weight: 900;
    text-align: center;
    position: sticky;
    top: 44px;
    background-color: #006688;
    text-transform: capitalize;

}

.default-table-body {
    display: table-row-group;
}

.default-table-row {
    display: table-row;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
}

.table-body-cell {
    max-width: 725px;
    display: table-cell;
    text-align: left;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
    padding: 5px 10px;
    background: #FFFFFF;
    vertical-align: middle;

    &:first-child {
        border-left: 1px solid #ddd;
        text-align: center;
    }

    &:last-child {
        text-align: right;
    }
}


.pagination {
    display: flex;
    justify-content: flex-end;
    margin: 8px 0;

    .page-item {
        user-select: none;
        overflow: visible;
        font-size: 15px !important;
        height: 35px !important;
        -webkit-border-radius: 0 !important;
        border-radius: 0 !important;
        color: #28282a !important;
        background: transparent !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid #000 !important;
        line-height: 31px !important;
        padding: 0 8px 1px !important;
    }
}

.page-link {
    user-select: none;
    overflow: visible;
    font-size: 15px !important;
    height: 35px !important;
    -webkit-border-radius: 0 !important;
    border-radius: 0 !important;
    color: #28282a !important;
    background: transparent !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: 1px solid #000 !important;
    line-height: 31px !important;
    padding: 0 8px 1px !important;
}

.mobile-table {
    display: none;
    border: 1px solid #ccc;
    @media screen and (max-width: 768px) {
        display: block;
    }
}

.mobile-table-row {
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
}

.mobile-department {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    background-color: rgb(160, 32, 96);
    color: #FFFFFF;
    font-weight: 700;
    font-size: 13px;
    text-transform: capitalize;
}

.mobile-department {
    div:last-child {
        text-align: right;
    }
}

.mobile-table-row-header {
    padding: 10px;
    text-align: left;
    font-size: 13px;

}

.mobile-table-row-content {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    text-align: right;
    font-size: 13px;
    text-transform: capitalize;

    div {
        display: flex;
        align-items: center;
        @media screen and (max-width: 510px) {
            max-width: 150px;
        }
    }
}

.mobile-table-row-content:last-child {
    background-color: rgb(240, 240, 240);
}

.mobile-table-row-content:nth-child(-n+4) {
    font-weight: 700;
}
</style>

<style lang="scss">
.page-item {
    font-family: Arial, sans-serif;
    cursor: pointer;
    margin-left: 6.5px;
    overflow: visible;
    font-size: 15px;
    line-height: 31px !important;

    .page-link {
        padding: 9px 11px 7px;
        font-size: 13px;
        height: 30px;
        display: flex;
        align-items: center;
        border: 1px solid #E0E0E0;
        color: #666 !important;
    }
}





 .page-item.active button {
    border: 1px solid #c1c1c1 !important;
}

 .page-item.disabled button{
   opacity: 0;
} 
.page-item.active {
    .page-link {
        color: #000 !important;
        border: 1px solid #00b6cc !important;
    }
}

.page-item .page-link:not(.pagination-link--disable):hover {
        color: #000 !important;
        border: 1px solid #00b6cc !important;
    }


.page-item.disabled > span {
    text-decoration: none !important;
    cursor: default;
    border: 1px solid #E0E0E0;
}

.department {
    color: #fff;
    font-weight: 700;
    font-size: 13px;
    text-align: left;
    background-color: rgb(160, 32, 96);

    td {
        padding: 4px;
    }
}
</style>